<script>
    export let text;
</script>
<div class="edit-option">
    <label>
        <input type="radio"> <input type="text" bind:value={text} />
    </label>
</div>
